// @ts-nocheck

import { matchPath } from 'react-router-dom';

import { RoutePatterns } from '../../types/routes';

export default (pathname) => !!matchPath(pathname, { path: RoutePatterns.LIVE, exact: true });
